import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import { useState } from "react";
// import { useGeolocated } from "react-geolocated";
// import GoogleMapReact from "google-map-react";
import { GoogleMap, useJsApiLoader, PolygonF } from "@react-google-maps/api";
import {
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  Grid,
  Typography,
  Box,
  // Button,
  IconButton,
  CircularProgress,
} from "@mui/material";
import AppConfig from "../../../../appConfig";

const containerStyle = {
  width: "100%",
  height: "400px",
};

function GPSPerimeter({ displayName, fieldRef, isOptional, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const [coords, setCoords] = useState(null);
  const [gpsLocationCoords, setGpsLocationCoords] = useState([]);
  const [openMapDialog, setOpenMapDialog] = useState(false);
  const [tracking, setTracking] = useState(false);
  const [watchId, setWatchId] = useState(null);

  function successCallback(position) {
    // const latitude = position.coords.latitude;
    // const longitude = position.coords.longitude;
    // console.log("Latitude:", latitude);
    // console.log("Longitude:", longitude);
    // console.log("Bearing:", position.bearing);
    // Do something with the coordinates
    const temp = gpsLocationCoords;
    temp.push({
      lat: position.coords.latitude,
      lng: position.coords.longitude,
      //   bearing: position.bearing,
      //   elevation: position.elevation,
    });
    setGpsLocationCoords(temp);
  }

  function errorCallback(error) {
    let errM = "";
    switch (error.code) {
      case error.PERMISSION_DENIED:
        errM = "User denied the request for Geolocation.";
        break;
      case error.POSITION_UNAVAILABLE:
        errM = "Location information is unavailable.";
        break;
      case error.TIMEOUT:
        errM = "The request to get user location timed out. Re-trying now.";
        break;
      default:
        errM = "An unknown error occurred.";
    }
    setErrorMsg(errM);
    showFieldError(true);
    if (options) {
      console.log("");
    }
  }

  function startTracking() {
    if (navigator.geolocation) {
      // Options for watchPosition (optional)
      const mapOptions = {
        enableHighAccuracy: true, // Use GPS if available for better accuracy
        timeout: 10000, // Maximum time to wait for a position
        maximumAge: 0, // Don't use cached position
      };

      if (gpsLocationCoords.length > 0) {
        if (window.confirm("Clear previous tracking?") === true) {
          setGpsLocationCoords([]);
        }
      }

      // Start watching the position and store the ID
      const wId = navigator.geolocation.watchPosition(successCallback, errorCallback, mapOptions);
      // console.log(wId);
      setWatchId(wId);

      // To stop watching the position later:
      // navigator.geolocation.clearWatch(watchId);
    } else {
      setErrorMsg("Geolocation is not supported by this browser.");
      showFieldError(true);
    }
  }

  function stoptracking() {
    // To stop watching the position later:
    console.log(watchId);
    navigator.geolocation.clearWatch(watchId);
  }

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: AppConfig.google_map_key,
  });

  // const [polygonPath, setPolygonPath] = useState(gpsLocationCoords);

  // const onPolygonChange = useCallback((e) => {
  //   setPolygonPath(
  //     e
  //       .getPath()
  //       .getArray()
  //       .map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() }))
  //   );
  // }, []);

  const mapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
  };

  return (
    <Box mt={3}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openMapDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box display="flex" justifyContent="space-between">
            <Box>GPS Perimeter Tracker </Box>
            <Box
              variant="button"
              color="grey"
              size="small"
              onClick={() => {
                stoptracking();
                setTracking(false);
                setGpsLocationCoords([]);
                setCoords(null);
                setOpenMapDialog(false);
              }}
              align="right"
            >
              <Icon>cancel</Icon>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box mt={2} mb={3}>
            {tracking ? (
              <Box align="center">
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <CircularProgress
                    // variant="determinate"
                    size={120}
                    thickness={2}
                    color="info"
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon color="info" fontSize="large">
                      gps_not_fixed
                    </Icon>
                  </Box>
                </Box>
                <Typography mt={3}>
                  Tracking...
                  <br />
                  <small>Start moving to track your location</small>
                </Typography>
              </Box>
            ) : (
              <Box>
                {gpsLocationCoords.length > 0 && isLoaded ? (
                  <div style={{ width: "100%" }}>
                    <GoogleMap
                      mapContainerStyle={containerStyle}
                      center={{
                        lat: gpsLocationCoords[0].lat, // 9.084576,
                        lng: gpsLocationCoords[0].lng, // 8.674252,
                      }}
                      zoom={19}
                      options={mapOptions}
                    >
                      <PolygonF
                        paths={gpsLocationCoords}
                        editable={false}
                        // onMouseUp={onPolygonChange}
                        // onDragEnd={onPolygonChange}
                        options={{
                          fillColor: "#FF0000",
                          fillOpacity: 0.3,
                          strokeColor: "#F94449",
                          strokeWeight: 2,
                        }}
                      />
                    </GoogleMap>
                    {/* <GoogleMapReact
                      bootstrapURLKeys={{ key: AppConfig.google_map_key }}
                      defaultCenter={{
                        lat: 9.084576,
                        lng: 8.674252,
                      }}
                      defaultZoom={11}
                      zoom={11}
                    >
                      {gpsLocationCoords.map((coord, idx) => (
                        <Box lat={coord.lat} lng={coord.lng}>
                          <Typography fontSize={24}>
                            <Icon color="error">location_on</Icon>
                          </Typography>
                        </Box>
                      ))}
                    </GoogleMapReact> */}
                    {/* <GoogleMapReact
                      bootstrapURLKeys={{ key: AppConfig.google_map_key }}
                      defaultCenter={{
                        lat: 9.084576,
                        lng: 8.674252,
                      }}
                      defaultZoom={8}
                      zoom={9}
                    >
                      {gpsLocationCoords.map((coord) => {
                        // console.log(loc.lat);
                        return (
                          // <AnyReactComponent
                          //   cRef={loc.reference}
                          //   lat={loc.lat}
                          //   lng={loc.lng}
                          //   text="My Marker"
                          // />
                          <Box lat={coord.lat} lng={coord.lng}>
                            <Typography fontSize={24}>
                              <Icon color="error">location_on</Icon>
                            </Typography>
                          </Box>
                        );
                      })}
                    </GoogleMapReact> */}
                  </div>
                ) : (
                  <Typography align="center" mt={3}>
                    Tracking inactive.
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          {gpsLocationCoords.length > 0 && tracking === false && (
            <MDButton
              variant="outlined"
              size="small"
              onClick={() => {
                setGpsLocationCoords([]);
                setCoords([]);
              }}
              color="warning"
              startIcon={<Icon>clear</Icon>}
            >
              Clear
            </MDButton>
          )}
          &nbsp;
          <MDButton
            color={tracking ? "error" : "info"}
            variant="outlined"
            size="small"
            onClick={() => {
              if (tracking) {
                stoptracking();
                setTracking(false);
              } else {
                startTracking();
                setTracking(true);
              }
            }}
            startIcon={<Icon>{tracking ? "stop" : "play_arrow"}</Icon>}
          >
            {tracking ? "Stop" : "Start"}
          </MDButton>
          &nbsp;
          <MDButton
            color="success"
            variant="contained"
            size="small"
            onClick={() => {
              if (gpsLocationCoords.length <= 0) {
                return;
              }

              if (tracking) {
                stoptracking();
                setTracking(false);
              }

              setCoords(gpsLocationCoords);
              setOpenMapDialog(false);
            }}
          >
            <Icon>save</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={8} md={8} lg={8}>
            <Typography variant="h6" fontWeight="light" fontSize="small" mb={2}>
              {displayName}
            </Typography>
          </Grid>
          <Grid item xs={4} md={4} lg={4}>
            <Box align="right">
              <IconButton
                iconOnly
                size="small"
                variant="contained"
                color="primary"
                onClick={() => {
                  setOpenMapDialog(true);
                }}
              >
                <Icon>location_searching</Icon>
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box>
        {gpsLocationCoords.length > 0 && (
          <>
            <Typography variant="caption" fontSize={14} fontWeight="light">
              Start: {JSON.stringify(gpsLocationCoords[0])}
              <br />
              End: {JSON.stringify(gpsLocationCoords[gpsLocationCoords.length - 1])}
            </Typography>
            <input type="hidden" id={`dff_${fieldRef}`} name={`${fieldRef}`} value={coords} />
          </>
        )}
      </Box>
    </Box>
  );
}

// Typechecking props of the Transaction
GPSPerimeter.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

GPSPerimeter.defaultProps = {
  options: null,
};

export default GPSPerimeter;
